function Logo() {
  return (
    <div className="flex items-center gap-3">
      <div className="grid h-10 w-10 place-items-center rounded-md border border-cyan-300/35 bg-cyan-300/10 text-sm font-extrabold text-cyan-300">
        EL
      </div>
      <div className="leading-tight">
        <div className="text-xl font-extrabold tracking-tight text-white">ELTT</div>
        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-cyan-300/75">
          elektroinstalace
        </div>
      </div>
    </div>
  );
}

export default Logo;
